// [BD feat] START Video with tabs section feature
(function () {
  'use strict';

  function initVTA(root) {
    if (!root || root.__vtaInit) return;
    root.__vtaInit = true;

    const single = root.dataset.singleOpen === 'true';

    // ----------------------------
    // Tabs
    // ----------------------------
    const tabs = Array.prototype.slice.call(root.querySelectorAll('.vta-tab'));

    tabs.forEach(function (tab) {
      const btn = tab.querySelector('button');
      if (!btn) return;

      btn.addEventListener('click', function () {
        if (single) {
          tabs.forEach(function (t) {
            if (t !== tab) {
              t.classList.remove('active');
              const b = t.querySelector('button');
              if (b) b.setAttribute('aria-expanded', 'false');
            }
          });
        }

        const willBeActive = !tab.classList.contains('active');
        tab.classList.toggle('active', willBeActive);
        btn.setAttribute('aria-expanded', willBeActive ? 'true' : 'false');
      });
    });

    // ----------------------------
    // Video play overlay toggle
    // ----------------------------
    const toggleBtn = root.querySelector('[data-vta-toggle-play]');
    const videoWrap = root.querySelector('[data-vta-video-wrap]');

    if (toggleBtn && videoWrap) {
      const getActiveVideo = function () {
        const vids = Array.prototype.slice.call(videoWrap.querySelectorAll('video'));
        const visible = vids.find(function (v) { return v.offsetParent !== null; }) || vids[0];
        return visible || null;
      };

      const pauseAll = function () {
        videoWrap.querySelectorAll('video').forEach(function (v) {
          try { v.pause(); } catch (e) {}
        });
      };

      pauseAll();
      setTimeout(pauseAll, 60);
      setTimeout(pauseAll, 250);

      toggleBtn.addEventListener('click', function () {
        const videoEl = getActiveVideo();
        if (!videoEl) return;

        videoEl.loop = true;
        videoEl.setAttribute('loop', '');
        videoEl.muted = true;

        try { videoEl.play(); } catch (e) {}

        toggleBtn.classList.add('is-playing');
        toggleBtn.style.display = 'none';
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-vta-root]').forEach(function (root) {
      initVTA(root);
    });
  }

  // Normal page load
  document.addEventListener('DOMContentLoaded', initAll);

  // Shopify Theme Editor (important when you add/remove sections)
  document.addEventListener('shopify:section:load', function (evt) {
    if (!evt || !evt.target) return;
    evt.target.querySelectorAll('[data-vta-root]').forEach(function (root) {
      initVTA(root);
    });
  });

})();
// [BD feat] END Video with tabs section feature